import { AspenApiActions, AspenApiActionTypes } from './aspen-api-actions'

export interface AspenApiState {
    version: string
    alembicVersion: string
    analyticsDatabase: string
}

export const initialAspenApiState: AspenApiState = { version: '', alembicVersion: '', analyticsDatabase: '' }

export function aspenApiReducer(previousState: AspenApiState | undefined, action: AspenApiActions): AspenApiState {
    const state = previousState || initialAspenApiState

    switch (action.type) {
        case AspenApiActionTypes.SET_ASPEN_VERSION:
            return {
                ...state,
                version: action.payload.version,
                alembicVersion: action.payload.alembicVersion,
                analyticsDatabase: action.payload.analyticsDatabase
            }
        default:
            return state
    }
}
